var ambiente = require('../../../config/configuracao-ambiente-npm-dev.json');

var url_host_vue = ambiente.Config.DESENVOLVEDOR + '.vue.' + ambiente.Config.LEILOEIRO + '.vlance-dev';
var url_host_php = ambiente.Config.DESENVOLVEDOR + '.' + ambiente.Config.LEILOEIRO + '.vlance-dev';

window.HOSTNAME = window.location.hostname == url_host_vue ? url_host_php : window.location.hostname
if (window.location.port !== '' && window.location.hostname !== url_host_vue) {
   window.HOSTNAME += ':' + window.location.port
}


// WEBPACK FOOTER //
// ./src/assets/js/configUrl-npm.js